<template>
  <div id="backstage-canvas">
    <img
      v-show="!hideBackstageImage"
      src="../assets/backstage.jpg"
      style="position: absolute; width: 100%;height: 100%;"
    />
    <div id="screen-share-panel"></div>
    <!--    <div id="timer" v-if="this.timerStartSession !== 10">-->
    <!--      <span id="timer-text">Session will live in </span>-->
    <!--      <br />-->
    <!--      <span id="timer-seconds">00:0{{ timerStartSession }} seconds</span>-->
    <!--    </div>-->
    <drag-it-dude
      style="z-index: 9;position: absolute; left: 30%;top: 5%"
      @activated="handleActivated"
      @dragging="handleDragging"
      @dropped="handleDropped"
    >
      <div
        v-show="!closeDialog"
        id="draggableBox"
        style="display: block;width: fit-content;min-width: 450px;position: absolute; border-radius: 10px;left: 30%; top: 5%;z-index: 5; padding: 30px;background: rgba(31, 31, 31, .9);color: #fff; text-align: center"
      >
        <span @click="closeBox" style="position: absolute;right: 10px;top: 10px"
          ><i class="fa fa-times" aria-hidden="true"></i
        ></span>
        <p v-show="attendeeMode == 'host'">
          Welcome to Meetbeans Studio, here you can manage event and communicate with the speakers.
        </p>
        <p v-show="attendeeMode == 'speaker'">
          Welcome to Meetbeans Studio, here you can communicate with the fellow speakers.
        </p>
      </div>
    </drag-it-dude>
    <div class="ag-btn-group">
      <div style="display: flex; justify-content: space-between">
        <span
          class="ag-btn videoControlBtn tooltip"
          @click="handleCamera"
          title="Enable/Disable Video"
        >
          <i class="fas fa-video-slash"></i>
          <i class="fas fa-video"></i>
          <span class="tooltiptext">Enable/Disable Camera</span>
        </span>
        <span
          class="ag-btn audioControlBtn tooltip"
          @click="handleMic"
          title="Enable/Disable Audio"
        >
          <i class="fas fa-microphone-slash"></i>
          <i class="fas fa-microphone"></i>
          <span class="tooltiptext">Enable/Disable Microphone</span>
        </span>
        <span
            class="ag-btn recordingControlBtn tooltip"
            title="Start/Stop Recording"
            style="background: #5f5f5f"
          >
            <i class="fas fa-stop"></i>
            <i class="fas fa-play"></i>
            <span class="tooltiptext">Start/Stop Recording</span>
          </span>
      </div>
      <div style="margin: 0 auto;margin-bottom: 10px" class="text-center">
        <div id="timer" v-if="this.timerStartSession !== 10">
          <span id="timer-text">Session will live in </span>
          <span id="timer-seconds">{{ timerStartSession }} seconds</span>
        </div>
        <button
          v-if="this.attendeeMode === 'host' && this.timerStartSession === 10"
          class="btn btn-primary"
          id="start-session"
          @click="startSession"
          :disabled="this.$store.state.isSessionTimerDisabled"
        >
          Start Session
        </button>
        <button
          v-if="
            this.attendeeMode === 'host' &&
              this.timerStartSession > 0 &&
              this.timerStartSession < 10
          "
          class="btn btn-danger"
          id="stop-timer"
          @click="stopSessionTimer"
        >
          Stop Timer
        </button>
        <button
          id="speaker-instruction"
          v-if="this.attendeeMode === 'speaker'"
          class="btn btn-primary tooltip"
          disabled
        >
          Start Streaming
          <span class="tooltiptext" style="width: 300px;margin-left: -150px">Use this button to start your video after host starts the session</span>
        </button>
      </div>
      <div style="display: flex;justify-content: center;float: right">
        <button
          v-if="!isActiveScreenShare"
          @click="handleScreenShare"
          class="ag-btn displayModeBtn d-none d-md-block"
          id="screen-share"
          title="Switch Display Mode"
          style="padding: 5px 20px;"
          :class="{ disableButton: isScreenBeingSharedByRemote }"
          :disabled="this.$store.state.isBackstageScreenShare"
        >
          <div style="display: grid;">
            <i class="fas fa-share" style="margin-left: 12px;"></i>
            <i style="font-size: 10px;" class="text-primary">Screen Share</i>
          </div>
        </button>
      </div>
    </div>
    <div v-if="isSpeakerLoaderScreen" class="text-center">
      <div id="loaderScreen">
        <img src="../assets/loader.gif" width="70" height="70" />
        <p>Loading..</p>
      </div>
    </div>
    <div v-if="isActiveScreenShare" class="text-center">
      <div id="loaderScreen">
        <h4>You are presenting...</h4>
        <button
          @click="handleStopScreenShare"
          class="btn btn-outline-danger"
          id="stop-share"
          title="Switch Display Mode"
          style="padding: 5px 20px;width: 140px;height: 50px;"
        >
          Stop Share
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AgoraRTC from "agora-rtc-sdk";
import jquery from "jquery";
import { merge } from "lodash";
import DragItDude from "vue-drag-it-dude";
// import ScreenShare from "@/components/screenShare.vue";
import "intro.js/minified/introjs.min.css";

const introJS = require("intro.js");

export default {
  components: {
    DragItDude,
    // ScreenShare
  },
  data() {
    return {
      displayMode: "grid",
      closeDialog: false,
      hideBackstageImage: false,
      youtubeStreamUrl: "rtmps://live-api-s.youtube.com:443/rtmp/",
      client: {},
      screenClient: {},
      channel: "",
      channel_name: "",
      token: "",
      attendeeMode: "",
      uid: "",
      streamList: [],
      localStream: "",
      screenStream: "",
      appID: "69ef6e3390ff4e32b01d68cf54610419",
      mode: "rtc",
      codec: "vp8",
      isOnline: "",
      memberList: [],
      timerStartSession: 10,
      isSpeakerLoaderScreen: false,
      isActiveScreenShare: false,
      isScreenBeingSharedByRemote: false,
      screenUid: "",
      screenShareToken: "",
    };
  },
  mounted() {
    const $ = this;
    let da = {
      channel_id: this.$route.params.id,
    };
    this.$store.dispatch("getMembersData", da).then((resp) => {
      if (resp.data.status === "success") {
        resp.data.data.forEach((m) => {
          $.memberList.push(m);
        });
      }
    });
    this.getAgoraBackstageToken();
    $.$root.$on("speakerLoaderScreenStart", () => {
      $.isSpeakerLoaderScreen = false;
    });
    $.$root.$on("speakerLoaderScreenStop", () => {
      $.isSpeakerLoaderScreen = false;
    });
    $.$root.$on("clientpleaseemptylocalstream", () => {
      // unpublish your stream if you are publishing
      if ($.localStream !== undefined) {
        // Stop playing the local stream
        // $.localStream.stop();
        // Close the local stream
        $.localStream.close();
        $.client.unpublish($.localStream);
        $.removeStream($.uid);
      }
    });
    $.$root.$on("hideHost_1", (data) => {
      $.hiddenUid = data.id;
      if (!data.isHidden) {
        $.handleHideHost();
      } else {
        $.handleUnhideHost();
      }
    });
    $.$root.$on("unhideHost_1", () => {
      $.handleUnhideHost();
    });
    $.$root.$on("hostIsHidden", (data) => {
      console.log("Hidden Host: ", data);
      $.hiddenUid = data.id;
      $.$store.state.isHostHidden = true;
      if ($.$store.state.isHostHidden) {
        $.handleHideHost();
      } else {
        $.handleUnhideHost();
      }
    });
    $.$root.$on("hostIsUnhidden", () => {
      console.log("Unhidden host id: ");
      $.$store.state.isHostHidden = false;
      $.handleUnhideHost();
    });
    $.$root.$on("unpublishSpeakers", () => {
      // console.log("attende modes: ", this.attendeeMode);

      if (this.attendeeMode === "speaker") {
        // $.removeStream(this.localStream);
        $.localStream.stop();
        $.localStream && this.localStream.close();
        $.client && this.client.unpublish(this.localStream);
        $.client &&
          $.client.leave(
            () => {
              console.log("Client succeed to leave.");
            },
            () => {
              console.log("Client failed to leave.");
            }
          );
      }
    });
    $.$root.$on("clientScreenShareHasStarted", (uid) => {
      console.log(uid);
      $.isScreenBeingSharedByRemote = true;
    });
    $.$root.$on("clientScreenShareHasStopped", (uid) => {
      console.log(uid);
      // making isScreenShare false on client side
      $.isScreenBeingSharedByRemote = false;
      $.backstageLayout();
    });
    $.$root.$on("handlesubmitSetting", (packet) => {
      // console.log(" video call packet: ", packet);
      packet.req.forEach((item) => {
        if (
          item.type === "video" &&
          item.deviceId !== this.$store.state.cameraId
        ) {
          $.localStream.switchDevice(
            `video`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
                queue: true
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.cameraId = item.deviceId;
        }
        if (
          item.type === "audio" &&
          item.deviceId !== this.$store.state.microphoneId
        ) {
          $.localStream.switchDevice(
            `audio`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
                queue: true
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.microphoneId = item.deviceId;
        }
      });
    });
    introJS.introJs().setOptions({
      hints: [
            {
              element: document.querySelector("#liveBtn"),
              hint: "Special feature to go live on social media like facebook, youtube",
              hintPosition: "left",
            },
            {
              element: document.querySelector("#hiddenBtn"),
              hint: "Use this option if you want to hide your video and mute yourself",
              hintPosition: "left",
            }
          ]
    })
    .addHints();
  },
  methods: {
    handleHideHost() {
      this.streamList.forEach(stream => {
        if(stream.getId() == this.hiddenUid) {
          stream.muteAudio();
          stream.muteVideo();
        }
      })
      this.$store.state.isHostHidden = true;
      this.canvasLayout();
      this.$toast.open({
        message: "You are hidden now.",
        type: "success",
        position: "top",
        queue: true
      });
    },
    handleUnhideHost() {
      let $ = this;
      $.streamList.forEach(stream => {
        if(stream.getId() == $.hiddenUid) {
          stream.unmuteAudio();
          stream.unmuteVideo();
        }
      })
      if (document.querySelector(".videoControlBtn")) {
        document.querySelector(".videoControlBtn").classList.remove("off");
      }
      if (document.querySelector(".audioControlBtn")) {
        document.querySelector(".audioControlBtn").classList.remove("off");
      }
      $.$store.state.isHostHidden = false;

      $.canvasLayout();
    },
    handleActivated() {
      document.querySelector("#draggableBox").style.cursor = "grab";
    },
    handleDragging() {
      document.querySelector("#draggableBox").style.cursor = "grabbing";
    },
    handleDropped() {
      document.querySelector("#draggableBox").style.cursor = "grab";
    },
    closeBox() {
      this.closeDialog = !this.closeDialog;
    },
    addImage(user) {
      // let te = document.getElementById(`player_${user.uid}`);
      var img = document.createElement("img");
      img.src = `${user.photoURL}`;
      img.setAttribute("id", `user_photo_client_${user.uid}`);
      img.style.position = "absolute";
      img.style.top = "50%";
      img.style.left = "50%";
      img.style.transform = "translate(-50%, -50%)";
      img.style.borderRadius = "300px";
      img.style.zIndex = "1";
      img.style.backgroundSize = "contain";
      var img2 = document.createElement("img");
      img2.src = `${user.photoURL}`;
      img2.setAttribute("id", `user_photo_client_blur_${user.uid}`);
      img2.style.position = "absolute";
      img2.style.filter = "blur(4px)";
      img2.style.minHeight = "100%";
      img2.style.minWidth = "100%";
      if (document.querySelector(`#player_${user.uid}`)) {
        document.querySelector(`#player_${user.uid}`).appendChild(img);
        document.querySelector(`#player_${user.uid}`).appendChild(img2);
      }
    },
    removeImage(id) {
      // console.log(jquery(`#user_photo_client_${id}`));
      jquery(`#user_photo_client_${id}`).remove();
      jquery(`#user_photo_client_blur_${id}`).remove();
    },
    handleScreenShare() {
      const $ = this;
      $.isSpeakerLoaderScreen = true;
      $.$store.state.isBackstageScreenShare = true;
      $.getScreenShareTableTokenFunction();
      $.isScreenBeingSharedByRemote = true;
    },
    handleStopScreenShare() {
      const $ = this;
      $.isActiveScreenShare = false;
      $.$store.state.isBackstageScreenShare = false;
      $.isScreenBeingSharedByRemote = false;
      $.isSpeakerLoaderScreen = false;
      $.handleStopShare();
      let bc = document.querySelector("#backstage-canvas");
      bc.setAttribute(
        "style",
        `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
      );

      let panel = document.querySelector("#screen-share-panel");
      panel.setAttribute(
        "style",
        `display: flex;flex-direction: column;width: 100%; height: 85vh;  z-index: 9;`
      );
    },
    handleStopShare() {
      const $ = this;
      $.screenStream.stop();
      $.screenStream && $.screenStream.close();
      $.screenClient &&
        $.screenClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
      $.backstageLayout();
      $.$root.$emit("clientScreenShareStopped");
    },
    screenShareClient() {
      const $ = this;
      // create the client fot screenshare
      $.screenClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });

      $.screenClient.init($.appID, () => {
        // console.log("AgoraRTC screen stream initialized");
        $.$root.$emit("screenShareLoaderStart");
        // $.subscribeScreenStreamEvents();
        // console.log(
        //   " Backstage details:  ",
        //   $.screenShareToken,
        //   " ",
        //   $.channel,
        //   " ",
        //   $.screenUid
        // );
        $.screenClient.join(
          $.screenShareToken,
          $.channel,
          $.screenUid,
          (uid) => {
            console.log(uid);
            const data = {
              screenUid: $.screenUid,
              attendeeMode: "screenshare",
              videoProfile: {},
              config: {},
            };
            $.screenStream = $.streamInit(
              data.screenUid,
              data.attendeeMode,
              data.videoProfile,
              data.config
            );
            $.screenStream.init(
              () => {
                $.isActiveScreenShare = true;
                $.$root.$emit(
                  "clientScreenShareStarted",
                  $.screenStream.getId()
                );

                $.addStream($.screenStream, true);
                $.screenClient.publish($.screenStream, (err) => {
                  console.log("Publish local stream error: " + err);
                });
                $.isSpeakerLoaderScreen = false;
                setTimeout(() => {
                  $.$root.$emit("screenShareLoaderStop");
                }, 2000);
              },
              (err) => {
                $.$toast.open({
                  message: `Screen Share Cancelled`,
                  type: `${err.type}`,
                  position: "top",
                  queue: true
                });
                $.$root.$emit("screenShareLoaderStop");
                console.log("getUserMedia failed", err);
                $.handleStopScreenShare();
              }
            );
            $.screenStream.on("stopScreenSharing", () => {
              $.isActiveScreenShare = false;
              $.isScreenBeingSharedByRemote = false;
              $.handleStopScreenShare();
            });
          },
          (err) => {
            console.log("unable to create dummy client: ", err);
            $.removeStream($.screenStream.getId());
          }
        );
      });
    },
    getScreenShareTableTokenFunction() {
      const $ = this;
      let data = {
        channel_id: this.$route.params.id,
      };
      // dispatch the api request to get data for token and uid
      this.$store
        .dispatch("getScreenShareBackstageToken", data)
        .then((resp) => {
          if (resp.data.status === "success") {
            // Set the values for the token
            $.screenUid = resp.data.data.uid;
            $.screenShareToken = resp.data.data.rtc_token;
            // Call the screen share client
            $.screenShareClient();
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true
            });
          }
        });
    },
    handleMic(e) {
      e.currentTarget.classList.toggle("off");
      if (this.localStream.isAudioOn()) {
        this.$toast.open({
          message: "Mute",
          type: "info",
          position: "bottom",
          queue: true
        });
        this.localStream.disableAudio();
      } else {
        this.$toast.open({
          message: "Unmute",
          type: "success",
          position: "bottom",
          queue: true
        });
        this.localStream.enableAudio();
      }
    },
    handleCamera(e) {
      e.currentTarget.classList.toggle("off");
      let user_info = JSON.parse(localStorage.getItem("user_info"));
      if (this.localStream.isVideoOn()) {
        this.$toast.open({
          message: "Video is disable",
          type: "info",
          position: "bottom",
          queue: true
        });
        this.addImage(user_info);
        this.localStream.muteVideo();
      } else {
        this.$toast.open({
          message: "Video is enable",
          type: "success",
          position: "bottom",
          queue: true
        });
        this.localStream.unmuteVideo();
        this.removeImage(this.localStream.getId());
        // jquery(`#video${this.user.uid}`).show();
      }
    },
    startSession() {
      const $ = this;
      $.audio = new Audio("https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/countdown.mp3");
        $.audio.volume = .2;
        $.audio.play();
      $.$store.state.isSessionTimerDisabled = true;
      $.$root.$emit("clientStartTheSession");
      this.clr = setInterval(function() {
        // https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/countdown.mp3


        if ($.timerStartSession === 0) {
          $.timerStartSession = 10;
          $.handleExit();
          clearInterval($.clr);
          $.$store.state.isLive = true;
          $.$store.state.isNetworking = false;
          $.$store.state.isBreak = false;
          $.$store.state.isEnd = false;
          $.postMeetingStatus();
        } else {
          $.timerStartSession = $.timerStartSession - 1;
        }
        // console.log($.timerStartSession);
      }, 1000);
    },
    handleExit() {
      // this.postMeetingStatus();
      this.client && this.client.unpublish(this.localStream);
      this.localStream && this.localStream.close();
      this.client &&
        this.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
    },
    stopSessionTimer() {
      const $ = this;
      $.isSpeakerLoaderScreen = false;
      $.$store.state.isSessionTimerDisabled = false;
      this.timerStartSession = 10;
      this.audio.pause();
      clearInterval(this.clr);
      $.$root.$emit("clientHostHasStoppedTimer");
    },
    postMeetingStatus() {
      let data = {
        channel_id: this.$route.params.id,
      };
      this.$store.dispatch("storeMeetingStates", data).then((resp) => {
        if (resp.data.status === "success") {
          console.log("Wonderful states stored");
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true
          });
        }
      });
    },
    getAgoraBackstageToken() {
      const $ = this;
      let data = {
        channel_id: this.$route.params.id,
      };
      this.$store.dispatch("getAgoraBackstageToken", data).then((resp) => {
        if (resp.data.status === "success") {
          $.token = resp.data.data.rtc_token;
          $.channel = resp.data.data.unique_id;
          $.channel_name = resp.data.data.channel_name;
          $.attendeeMode = resp.data.data.role;
          $.uid = resp.data.data.uid;
          // console.log("Uid vs: ", $.uid, "token: ", $.token);
          $.$store.state.role = resp.data.data.role;
          this.handleClient();
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true
          });
        }
      });
    },
    handleMuteAudio(uid) {
      this.audioFlag = false;
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).show();
    },
    handleUnmuteAudio(uid) {
      this.audioFlag = true;
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).hide();
    },
    handleMuteVideo(uid) {
      this.videoFlag = false;
      // console.log("UID: ", uid);
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).show();
    },
    handleUnmuteVideo(uid) {
      this.videoFlag = true;
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).hide();
    },
    streamInit(uid, attendeeMode, videoProfile, config) {
      // videoProfile, config - not being used
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false,
        cameraId: this.$store.state.cameraId,
        microphoneId: this.$store.state.microphoneId,
      };
      switch (attendeeMode) {
        case "screenshare":
          defaultConfig.audio = false;
          defaultConfig.video = false;
          defaultConfig.screen = true;
          // defaultConfig.screenAudio = true;
          break;
        case "audio-only":
          defaultConfig.video = false;
          break;
        case "audience":
          defaultConfig.video = false;
          defaultConfig.audio = false;
          break;
        case "video":
          break;
        default:
          break;
      }
      let stream = AgoraRTC.createStream(merge(defaultConfig, config));
      stream.setVideoProfile("480p_4");
      // stream.setVideoProfile(videoProfile);
      return stream;
    },
    subscribeStreamEvents() {
      let $ = this;
      $.client.on('peer-online', (evt) => {
        // console.log('peer-online', evt.uid);
        if(evt.uid === 10000322) {
          $.isScreenBeingSharedByRemote = true;
        }
      });
      $.client.on("mute-audio", (evt) => {
        const $ = this;
        // console.log("client event mute audio: ", evt);
        $.handleMuteAudio(evt.uid);
      });
      $.client.on("unmute-audio", (evt) => {
        const $ = this;
        // console.log("client event unmute audio: ", evt);
        $.handleUnmuteAudio(evt.uid);
      });
      $.client.on("mute-video", (evt) => {
        const $ = this;
        // console.log("client event mute video: ", evt);
        $.memberList.forEach((m) => {
          if (m.uid == evt.uid) {
            $.addImage(m);
          }
        });
        $.handleMuteVideo(evt.uid);
      });

      $.client.on("unmute-video", (evt) => {
        const $ = this;
        // console.log("client event unmute video: ", evt);
        $.removeImage(evt.uid);
        $.handleUnmuteVideo(evt.uid);
      });

      $.client.on("connection-state-change", () => {});

      $.client.on("network-quality", (downLink) => {
        this.isOnline = downLink.downlinkNetworkQuality;
      });

      $.client.on("stream-type-changed", () => {
        console.log("STC :: Switched video to audio due to poor network.");
      });
      $.client.on("stream-fallback", () => {
        console.log("SF :: Switched video to audio due to poor network.");
      });
      $.client.on("stream-added", function(evt) {
        let remoteStream = evt.stream;
        // $.client.setStreamFallbackOption(remoteStream, 2);
        // $.addStream(remoteStream, true);
        console.log("ss add: ", remoteStream);
        $.client.subscribe(remoteStream, function(err) {
          console.log("Subscribe stream failed", err);
        });
      });

      $.client.on("stream-subscribed", function(evt) {
        let remoteStream = evt.stream;
        // console.log(
        //   "Subscribe remote stream successfully: " + remoteStream.getId()
        // );
        $.addStream(remoteStream, true);
      });

      // When remote user leave
      $.client.on("peer-leave", function(evt) {
        console.log("client event peer leave: ", evt);
        $.removeStream(evt.uid);
        // $.isSpeakerLoaderScreen = false;
        $.backstageLayout();
        // setTimeout(function() {
        //   $.isSpeakerLoaderScreen = false;
        // }, 1000);
      });

      // Remote stream is removed
      $.client.on("stream-removed", function(evt) {
        let stream = evt.stream;
        console.log("client event stream removed: ", evt);
        $.removeStream(stream.getId());
        //   $.isSpeakerLoaderScreen = false;
        $.backstageLayout();
        //   setTimeout(function() {
        //     $.isSpeakerLoaderScreen = false;
        //   }, 1000);
      });
    },
    addStream(stream) {
      const $ = this;
      let repeatition = $.streamList.some((item) => {
        return item.getId() == stream.getId();
      });

      if (repeatition) {
        return;
      }
       stream.preloadEffect(
        1,
        "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
        function(err) {
          if (err) {
            console.error("Failed to preload effect, reason: ", err);
          } else {
            console.log("Effect is preloaded successfully");
            stream.setEffectsVolume(10, function(err) {
              if (err) {
                console.error("Failed to set effects volume, reason: ", err);
              } else {
                console.log("Effects volume is set successfully");

            stream.playEffect(
              {
                soundId: 1,
                filePath: "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
              },
              function(err) {
                if (err) {
                  console.log("audio error");
                }
              }
            );
              }
            })
          }
        }
      );
      if ($.streamList.length <= 17) {
        $.isSpeakerLoaderScreen = false;

        $.streamList.push(stream);
        let no = $.streamList.length;
        if (no > 0) {
          $.streamList.map((item) => {
            let id = item.getId();
            // console.log("Vs Length: ", $.streamList.length, " name: ", id);
            let canvas = document.querySelector("#screen-share-panel");

            let dom = document.querySelector("#ag-item-" + id);

            if (!dom) {
              dom = document.createElement("section");
              dom.setAttribute("id", "ag-item-" + id);
              dom.setAttribute("class", "ag-item");

              if (id === 10000322) {
                canvas = document.querySelector("#backstage-canvas");
                canvas.appendChild(dom);
                item.play("ag-item-" + id, { fit: "contain" });
              } else {
                canvas.appendChild(dom);
                item.play("ag-item-" + id);

                // if (
                //   !document
                //     .getElementsByClassName("videoControlBtn")[0]
                //     .classList.contains("off")
                // ) {
                //   document
                //     .getElementsByClassName("videoControlBtn")[0]
                //     .classList.add("off");
                // let user_info = JSON.parse(localStorage.getItem("user_info"));
                // this.addImage(user_info);
                // $.memberList.map(m => {
                //   console.log('m : ', m);
                //   if(m.uid === id){
                //     this.addImage(m);
                //     item.muteVideo();
                //   }
                // })
                // }
              }
            }

            let length = $.streamList.length;

            if ($.isScreenBeingSharedByRemote) {
              let bc = document.querySelector("#backstage-canvas");
              bc.setAttribute(
                "style",
                `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
              );

              let panel = document.querySelector("#screen-share-panel");
              panel.setAttribute(
                "style",
                `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 99;`
              );
              if (id !== 10000322) {
                if ($.streamList.length < 8) {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 100%;height: 15vh`
                  );
                } else {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 50%;height: 10.62vh`
                  );
                }
              } else {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 85vh`
                );
              }
            } else {
              if (length == 1) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 0vh`
                );
              } else if (length == 2) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 85vh`
                );
              } else if (length >= 3 && length < 5) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 42.5vh`
                );
              } else if (length >= 5 && length < 7) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 33.3%;height: 42.5vh`
                );
              } else if (length >= 7 && length < 13) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 25%;height: 21.25vh`
                );
              } else if (length >= 13 && length < 18) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 20%;height: 21.25vh`
                );
              }
            }

            item.player.resize && item.player.resize();

            $.backstageLayout();

            setTimeout(function() {
              if (document.querySelector("#ag-item-" + id)) {
                const videoInfo = jquery("#video-info-" + id);
                // console.log("video length: ", videoInfo, videoInfo.length);
                if (videoInfo.length <= 1) {
                  $.handleVideoInfo(item);
                }
                // document.querySelector(".ag-item").style.height = "85vh"
                // setTimeout(function() {
                //   $.isSpeakerLoaderScreen = false;
                // }, 1000);
              }
            }, 1000);
          });
        }
      } else {
        $.$toast.open({
          message: "Only 17 users can join at a time.",
          type: "error",
          position: "top",
          queue: true
        });
      }
    },
    removeStream(uid) {
      const $ = this;
      $.streamList.map((item, index) => {
        if (item.getId() == uid) {
          item.stop();
          item.close();
          let element = document.querySelector("#ag-item-" + uid);

          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...$.streamList];
          tempList.splice(index, 1);
          // // steamlist
          $.streamList = tempList;
        }
      });
    },
    handleVideoInfo(stream) {
      const $ = this;
      // video information code
      let styles = {
        position: "absolute",
        bottom: "120px",
        background: "rgba(10, 10, 10, 0.75)",
        color: "#fff",
        padding: "4px",
        "font-size": "12px",
        "font-weight": "bold",
        width: "120px",
        height: "60px",
      };
      if($.isScreenBeingSharedByRemote){
       styles = {
        position: "absolute",
        bottom: "0px",
        background: "rgba(10, 10, 10, 0.75)",
        color: "#fff",
        padding: "4px",
        "font-size": "12px",
        "font-weight": "bold",
        width: "120px",
        height: "27px",
      };
      }
      const targetElement = document.getElementById("player_" + stream.getId());
      if (targetElement === null) {
        return;
      }
      const videoInfo = document.getElementById(`video-info-${stream.getId()}`);
      if (typeof videoInfo != "undefined" && videoInfo != null) {
        return;
      }

      $.memberList.forEach((m) => {
        if (m.uid == stream.getId()) {
          // if(document.querySelector(`user_photo_client_${m.uid}`) === null && m.uid != this.localStream.getId()) {
          //   $.addImage(m);
          // }
          const label = document.createElement("label");
          label.innerHTML = m.role.toUpperCase();
          if (m.role === "host") {
            label.setAttribute("class", "badge badge-danger");
          } else {
            label.setAttribute("class", "badge badge-info");
          }
          label.style.position = "absolute";
          label.style.left = "10px";
          label.style.top = "10px";
          label.style.zIndex = "9";
          targetElement.appendChild(label);
          let newElement = document.createElement("div");
          newElement.setAttribute("id", `video-info-${stream.getId()}`);
          newElement.setAttribute("class", "video-info");
          newElement.style.zIndex = "2";
          // const videoInfo = document.getElementById(`video-info-${m.uid}`);
          // if (typeof videoInfo != "undefined" && videoInfo != null) {
          //   return;
          // }
          if (m.company !== "" && m.designation !== "") {
            newElement.innerHTML = `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p><p id="desg_cpy" style='margin-bottom: 0px;font-size: 10px'>${m.designation}, ${m.company}</p>`;
          } else {
            newElement.innerHTML = `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p>`;
          }
          Object.assign(newElement.style, styles);
          targetElement.appendChild(newElement);
          if (stream.getId() != $.localStream.getId()) {
            const element = `
                    <div class="main-div" style="z-index:10000" >
                        <span class="audio-icon-div" style="z-index:10000">
                            <i class="fas fa-microphone-slash audio" type="button" style="display: none;background: transparent"></i>
                        </span>
                        <span class="video-icon-div" style="z-index:10000">
                            <i class="fas fa-video-slash video" type="button" style="display: none;background: transparent"></i>
                        </span>
                    </div>
                `;
            jquery(newElement).append(element);
          } else {
            // Yo
          }
        } else {
          // $.addImage(m);
        }
      });
    },
    handleClient() {
      const $ = this;

      // client initialization
      $.client = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });

      $.client.init($.appID, () => {
        // console.log("AgoraRTC client initialized");

        $.subscribeStreamEvents();

        $.client.join($.token, $.channel, $.uid, (uid) => {
          $.client.enableDualStream(
            () => {
              // console.log("Table video dual stream enabled");
              $.uid = uid;
              const data = {
                uid: $.uid,
                attendeeMode: "",
                videoProfile: {},
                config: {},
              };
              $.localStream = $.streamInit(
                data.uid,
                data.attendeeMode,
                data.videoProfile,
                data.config
              );
              $.localStream.init(
                () => {
                  $.addStream($.localStream, true);
                  $.hideBackstageImage = true;
                  $.$toast.open({
                    message: "You are ready to chat with speakers..",
                    type: "success",
                    position: "top",
                    queue: true
                  });
                  $.client.publish($.localStream, (err) => {
                    console.log("Publish local stream error: " + err);
                  });
                  jquery(window).on("beforeunload", function() {
                    return "Are you sure you want to leave?";
                  });
                },
                (err) => {
                  $.$toast.open({
                    message: `${err.info}. Go to settings or allow permissions from your browser and refresh the page.`,
                    type: `${err.type}`,
                    position: "top",
                    queue: true
                  });
                  console.log("getUserMedia failed", err);
                  if (err.info === "Permission denied") {
                    // handle Permission denied case
                  }
                }
              );
            },
            (err) => {
              console.log(" stream error: ", err);
            }
          );
        });
      });
    },

    backstageLayout() {
      const $ = this;

      let bc = document.querySelector("#backstage-canvas");
      bc.setAttribute(
        "style",
        `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden`
      );

      let panel = document.querySelector("#screen-share-panel");
      panel.setAttribute(
        "style",
        `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 99;`
      );

      let length = $.streamList.length;

      if ($.isScreenBeingSharedByRemote) {
        $.streamList.forEach((stream, index) => {
          let width = "";
          let height = "15vh";
          if (stream.getId() === 10000322) {
            width = "85%";
            height = "85vh";
          } else {
            if (index === 7) {
              let breaker = document.createElement("div");
              breaker.style.width = "0%";
              breaker.style.height = "0%";
              breaker.style.flexBasis = "100%";
              let parent = document.querySelector("#screen-share-panel");
              parent.insertBefore(breaker, parent.children[index + 1]);
            }
            width = "100%";
          }
          let label = document.getElementById(`video-info-${stream.getId()}`);
          // console.log("label: ", label);
          if (label !== null) {
            label.style.bottom = "0";
            label.style.height = "25px";
            label.firstChild.style.fontSize = ".9em";
            if (label.childNodes.length > 1) {
              label.childNodes[1].style.visibility = "hidden";
            }
          }
          if (document.querySelector(`#ag-item-${stream.getId()}`)) {
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.width = width;
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.height = height;
          }
        });
      } else {
        let panel = document.querySelector("#screen-share-panel");
        panel.setAttribute(
          "style",
          `display:flex; flex-wrap: wrap; width: 100%;height: 85vh;flex-direction: column`
        );

        if (length === 17) {
          $.streamList.forEach((stream, index) => {
            let width = "";
            let height = "";
            if (index > 0) {
              width = "33.2%";
            } else {
              width = "16.6%";
              height = "21.25vh";
            }
            height = "85vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.width = "120px";
              label.style.height = "60px";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 16) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "21.25vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 15) {
          $.streamList.forEach((stream, index) => {
            let width = "20%";
            let height = "";
            if (index == 0) {
              height = "85vh";
            } else if (index > 0 && index < 3) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 14) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 13) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index === 0) {
              height = "85vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 12) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "28.3vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 11) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "28.3vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 10) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "28.3%";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 9) {
          $.streamList.forEach((stream) => {
            let width = "33.3%";
            let height = "28.3vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 8) {
          $.streamList.forEach((stream) => {
            let width = "25%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 7) {
          $.streamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 6) {
          $.streamList.forEach((stream) => {
            let width = "33.3%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 5) {
          $.streamList.forEach((stream, index) => {
            let width = "33.3%";
            let height = "";
            if (index > 0) {
              height = "42.5";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 4) {
          $.streamList.forEach((stream) => {
            let width = "50%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 3) {
          $.streamList.forEach((stream, index) => {
            let width = "50%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 2) {
          $.streamList.forEach((stream) => {
            let width = "50%";
            let height = "85vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes.length > 1) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 1) {
          let width = "100%";
          let height = "85vh";
          if (document.querySelector(`#ag-item-${$.localStream.getId()}`)) {
            document.querySelector(
              `#ag-item-${$.localStream.getId()}`
            ).style.width = width;
            document.querySelector(
              `#ag-item-${$.localStream.getId()}`
            ).style.height = height;
          }
          let label = document.getElementById(
            `video-info-${$.localStream.getId()}`
          );
          // console.log("label: ", label);
          if (label !== null) {
            label.style.bottom = "120px";
            label.style.height = "auto";

            label.firstChild.style.fontSize = "12px";
            if (label.childNodes.length > 1) {
              label.childNodes[1].style.visibility = "visible";
            }
          }
        }

        // document.querySelector(`#ag-item-${$.localStream.getId()}`).style.bottom = "25px";
        //   if (document.querySelector(`#ag-item-${$.localStream.getId()}`)) {
        //     document.querySelector(
        //       `#ag-item-${$.localStream.getId()}`
        //     ).style.transitionDelay = "2s";
        //   }
      }
    },
  },
  beforeDestroy() {
    const $ = this;
    // console.log("hello backlols");
    if ($.attendeeMode === "host" && $.attendeeMode === "speaker") {
      $.$root.$emit("pleaseemptylocalstream");
    }
    if($.isActiveScreenShare){
      $.isActiveScreenShare = false;
      $.$store.state.isBackstageScreenShare = false;
      $.isScreenBeingSharedByRemote = false;
      $.$root.$emit("clientScreenShareStopped");
      $.screenClient && this.screenClient.unpublish(this.screenStream);
      $.screenStream && this.screenStream.close();
      $.screenClient &&
      $.screenClient.leave(
        () => {
          console.log("Screen Client succeed to leave.");
        },
        () => {
          console.log("Screen Client failed to leave.");
        }
      );
    }
    $.client && this.client.unpublish(this.localStream);
    $.localStream && this.localStream.close();
    $.client &&
      $.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  position: relative;
  z-index: 100000;
  opacity: 1;
  // display: inline-block;
  // border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #1f1f1f;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  font-size: 14px;
}
#backstage-canvas {
  // position: relative;
  display: flex;
  overflow: hidden;
  // position: relative;

  // transition: all 1s;
}
#screen-share-panel {
  display: flex;
  flex-wrap: wrap;
  // transition: flex .3s ease-out;
}
.ag-item {
  transition: 0.2s flex;
}
.ag-btn-group {
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
  display: flex;
  background-image: linear-gradient(transparent, #000);
  justify-content: space-between;
  align-items: center;
}
/*#timer {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  right: 20px;*/
/*  width: 150px;*/
/*  height: 70px;*/
/*  background: linear-gradient(*/
/*    to right bottom,*/
/*    rgba(0, 0, 0, 0.9),*/
/*    rgba(21, 21, 21, 0.7)*/
/*  );*/
/*  text-align: center;*/
/*  z-index: 85;*/
/*}*/
/*#timer-text {*/
/*  color: grey;*/
/*}*/
/*#timer-seconds {*/
/*  color: #4cd01f;*/
/*}*/
#loaderScreen {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: #000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
